import store_analyse from '@/store/mods/analyses/analyse'

export default {
    name: 'manage-resultat-tdr',
    components: {},
    props: {
        evolution_id: {
            type: Number,
            default: () => 0
        },
        demande_analyse: Object,
        toggler: Number,
        selected_analyse_info: Object
    },
    data() {
        return {
            resultat: '',
            choice_empty: false,
            save_loading: false,
            is_error: false,
            permission_is_denied: false,
            msg_error: ''
        }
    },

    watch: {
        toggler() {
            this.resultat = ''
            this.msg_error = ''
            this.clearError()
            this.resultat = this.demande_analyse.resultat_tdr
        },

        resultat() {
            this.clearError()
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        clearError() {
            this.choice_empty = false
            this.msg_error = ''
        },

        saveResultatTDR() {
            if (this.resultat === '') {
                this.choice_empty = true
                return
            }

            const data = {
                consultation_id: this.selected_analyse_info.consultation_id,
                evolution_id: this.evolution_id,
                user_id: this.selected_analyse_info.user_id,
                bulletin_id: this.selected_analyse_info.bulletin_id,
                demande_analyse_id: this.demande_analyse.demande_id,
                resultat: parseInt(this.resultat)
            }
            this.save_loading = true
            console.log(data);

            store_analyse.saveResultatTDR(data).then((response) => {
                if (response.success) {
                    this.successToast(response.message)
                    this.$emit('emitBulletinAnalyse')
                    this.$refs.manage_tdr.click()
                } else {
                    this.msg_error = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_error = 'Une erreur s\'est produite !'
            })
        }
    }
}